import { SelectOptionType } from 'shared/ui/form/Select/SelectList'

export interface SortingOptionsTypes {
  sort_by: string
  order: string
}

export const BRAND_SORTING_OPTIONS: SelectOptionType[] = [
  { label: 'Wszystkie', value: 'recommended' },
  { label: 'od A do Z', value: 'name-asc' },
  { label: 'od Z do A', value: 'name-desc' }
]

export const SORTING_OPTIONS: SelectOptionType[] = [
  { label: 'Polecane', value: 'recommended' },
  { label: 'Najtańsze', value: 'price-asc' },
  { label: 'Najdroższe', value: 'price-desc' },
  { label: 'Najtańsze za kg/litr', value: 'unit-price-asc' },
  { label: 'Najdroższe za kg/litr', value: 'unit-price-desc' },
  { label: 'od A do Z', value: 'name-asc' },
  { label: 'od Z do A', value: 'name-desc' }
]

export const PROMOTED_SORTING_OPTIONS: SelectOptionType[] = [
  { label: 'Polecane', value: 'recommended' },

  { label: 'Najtańsze', value: 'price-asc' },
  { label: 'Najdroższe', value: 'price-desc' },
  { label: 'Najtańsze Cena jednostkowa', value: 'unit-price-asc' },
  { label: 'Najdroższe Cena jednostkowa', value: 'unit-price-desc' },
  { label: 'od A do Z', value: 'name-asc' },
  { label: 'od Z do A', value: 'name-desc' },
  { label: 'Największa zniżka', value: 'special-offer-discount-desc' },
  { label: 'Najmniejsza zniżka', value: 'special-offer-discount-asc' }
]

export const getSortingOptionsBySelectValue = (value: string | string[]) => {
  let sortingOptions
  // @sieradz- default was the name but assumptions changed and we display
  // the short name so we sort by short name

  switch (value) {
    case 'recommended':
      sortingOptions = {}
      break
    case 'name-asc':
      sortingOptions = { sort_by: 'name_description_short', order: 'asc' }
      break
    case 'name-desc':
      sortingOptions = { sort_by: 'name_description_short', order: 'desc' }
      break
    case 'price-asc':
      sortingOptions = { sort_by: 'price', order: 'asc' }
      break
    case 'price-desc':
      sortingOptions = { sort_by: 'price', order: 'desc' }
      break
    case 'unit-price-asc':
      sortingOptions = { sort_by: 'price_per_unit', order: 'asc' }
      break
    case 'unit-price-desc':
      sortingOptions = { sort_by: 'price_per_unit', order: 'desc' }
      break
    default:
      sortingOptions = { sort_by: 'name_description_short', order: 'asc' }
  }

  return sortingOptions as SortingOptionsTypes
}

export const getSortingOptionsBySelectValueForBrand = (
  value: string | string[]
) => {
  let sortingOptions

  switch (value) {
    case 'recommended':
      sortingOptions = {}
      break
    case 'name-asc':
      sortingOptions = { sort_by: 'name', order: 'asc' }
      break
    case 'name-desc':
      sortingOptions = { sort_by: 'name', order: 'desc' }
      break
    default:
      sortingOptions = {}
  }

  return sortingOptions as SortingOptionsTypes
}

export const getSortingOptionsBySelectValueForUpselling = (
  value: string | string[]
) => {
  let sortingOptions

  switch (value) {
    case 'recommended':
      sortingOptions = {}
      break
    case 'price-desc':
      sortingOptions = { sort_by: 'price', order: 'desc' }
      break
    case 'price-asc':
      sortingOptions = { sort_by: 'price', order: 'asc' }
      break
    case 'special-offer-discount-desc':
      sortingOptions = { sort_by: 'special_offer_discount', order: 'desc' }
      break
    case 'special-offer-discount-asc':
      sortingOptions = { sort_by: 'special_offer_discount', order: 'asc' }
      break
    case 'unit-price-asc':
      sortingOptions = { sort_by: 'price_per_unit', order: 'asc' }
      break
    case 'unit-price-desc':
      sortingOptions = { sort_by: 'price_per_unit', order: 'desc' }
      break
    case 'name-desc':
      sortingOptions = { sort_by: 'name_description_short', order: 'desc' }
      break
    case 'name-asc':
    default:
      sortingOptions = { sort_by: 'name_description_short', order: 'asc' }
  }

  return sortingOptions as SortingOptionsTypes
}

export const getSelectValueBySortingOptions = (
  options: SortingOptionsTypes
) => {
  // @sieradz- default was the name but assumptions changed and we display
  // the short name so we sort by short_name
  switch (true) {
    // @sieradz - if it's recommended so we dont have options.sort_by && options.order
    case options.sort_by === undefined && options.order === undefined:
      return 'recommended'
    case options.sort_by === 'name_short' && options.order === 'asc':
      return 'name-asc'
    case options.sort_by === 'name_short' && options.order === 'desc':
      return 'name-desc'
    case options.sort_by === 'name_description_short' &&
      options.order === 'asc':
      return 'name-asc'
    case options.sort_by === 'name_description_short' &&
      options.order === 'desc':
      return 'name-desc'
    case options.sort_by === 'name' && options.order === 'asc':
      return 'name-asc'
    case options.sort_by === 'name' && options.order === 'desc':
      return 'name-desc'
    case options.sort_by === 'price' && options.order === 'asc':
      return 'price-asc'
    case options.sort_by === 'price' && options.order === 'desc':
      return 'price-desc'
    case options.sort_by === 'price_per_unit' && options.order === 'asc':
      return 'unit-price-asc'
    case options.sort_by === 'price_per_unit' && options.order === 'desc':
      return 'unit-price-desc'
    case options.sort_by === 'special_offer_discount' &&
      options.order === 'asc':
      return 'special-offer-discount-asc'
    case options.sort_by === 'special_offer_discount' &&
      options.order === 'desc':
      return 'special-offer-discount-desc'
    default:
      return 'name-asc'
  }
}
